var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 257,
    height: 57,
    viewBox: "0 0 257 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M255.299 46.8285L225.062 46.748L225.132 14.2383L255.362 14.3188L255.299 46.8285Z",
    fill: "url(#paint0_linear_1290_3041)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M226.737 15.4395L226.672 47.9492L256.908 48.0319L256.973 15.5222L226.737 15.4395Z",
    fill: "#FEBD39"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M226.736 15.548L225.132 14.2383L225.062 46.748L226.673 47.948L226.736 15.548Z",
    fill: "url(#paint1_linear_1290_3041)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M226.743 15.4383L256.999 15.5993L255.388 14.3993L225.133 14.2383L226.743 15.4383Z",
    fill: "url(#paint2_linear_1290_3041)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M238.756 39.9278C237.792 39.4741 237.025 38.8009 236.448 37.9009C235.871 37.0082 235.567 35.9326 235.535 34.6741H239.846C239.91 35.3839 240.125 35.9253 240.487 36.2985C240.848 36.6717 241.324 36.8619 241.907 36.8619C242.509 36.8619 242.979 36.7009 243.327 36.3863C243.676 36.0643 243.847 35.6253 243.847 35.0619C243.847 34.5863 243.708 34.1985 243.435 33.8839C243.156 33.5765 242.82 33.3204 242.414 33.1156C242.009 32.918 241.438 32.6839 240.696 32.4351C239.618 32.0546 238.743 31.6668 238.065 31.2863C237.386 30.9058 236.803 30.3351 236.309 29.5887C235.82 28.8424 235.573 27.8692 235.573 26.6619C235.573 24.8765 236.131 23.479 237.253 22.4619C238.376 21.4521 239.834 20.9473 241.641 20.9473C243.473 20.9473 244.95 21.4521 246.073 22.4619C247.195 23.4717 247.797 24.8839 247.873 26.6912H243.486C243.454 26.0692 243.258 25.5863 242.896 25.2278C242.535 24.8692 242.066 24.6936 241.495 24.6936C241.007 24.6936 240.607 24.8473 240.309 25.1473C240.011 25.4473 239.859 25.879 239.859 26.4497C239.859 27.0717 240.113 27.5546 240.62 27.8985C241.127 28.2424 241.913 28.6156 242.991 29.018C244.063 29.4351 244.938 29.8375 245.61 30.218C246.282 30.5985 246.859 31.1546 247.353 31.8863C247.841 32.618 248.089 33.5546 248.089 34.7034C248.089 35.8009 247.848 36.7887 247.366 37.6814C246.884 38.5741 246.187 39.2839 245.267 39.818C244.348 40.3448 243.27 40.6082 242.021 40.6082C240.81 40.6156 239.72 40.3887 238.756 39.9278Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M223.056 39.7249L193.105 46.9761L188.344 14.781L218.295 7.53711L223.056 39.7249Z",
    fill: "#A74E9E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M224.823 40.5218L194.879 47.773L190.117 15.5779L220.068 8.33398L224.823 40.5218Z",
    fill: "url(#paint3_linear_1290_3041)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M190.132 15.6886L188.344 14.7812L193.105 46.9764L194.88 47.7739L190.132 15.6886Z",
    fill: "url(#paint4_linear_1290_3041)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M190.119 15.5777L220.102 8.39962L218.333 7.60938L188.344 14.7801L190.119 15.5777Z",
    fill: "url(#paint5_linear_1290_3041)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M207.313 33.6965L212.011 32.5769L212.524 36.1257L204.238 38.1013L201.492 19.2233L205.081 18.3672L207.313 33.6965Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M185.496 46.7846L154.309 43.2358L157.174 9.70898L188.355 13.2504L185.496 46.7846Z",
    fill: "url(#paint6_linear_1290_3041)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M187.055 48.2045L155.867 44.6557L158.733 11.1289L189.914 14.6777L187.055 48.2045Z",
    fill: "url(#paint7_linear_1290_3041)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M158.721 11.2383L157.174 9.70898L154.309 43.2358L155.868 44.6553L158.721 11.2383Z",
    fill: "url(#paint8_linear_1290_3041)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M158.735 11.1285L189.936 14.7578L188.376 13.3383L157.176 9.70898L158.735 11.1285Z",
    fill: "url(#paint9_radial_1290_3041)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M172.541 22.1985L172.186 26.0619L177.582 26.7278L177.252 30.3205L171.857 29.6546L171.47 33.84L177.576 34.5936L177.233 38.318L167.102 37.0668L168.864 17.9766L178.996 19.2278L178.653 22.9522L172.541 22.1985Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M152.241 46.5951L109.02 46.4707L109.121 0L152.342 0.12439L152.241 46.5951Z",
    fill: "url(#paint10_linear_1290_3041)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M154.541 48.308L111.32 48.1909L111.422 1.71289L154.643 1.83728L154.541 48.308Z",
    fill: "url(#paint11_linear_1290_3041)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M111.416 1.87317L109.121 0L109.02 46.4707L111.321 48.1902L111.416 1.87317Z",
    fill: "url(#paint12_linear_1290_3041)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M111.423 1.7122L154.675 1.94634L152.374 0.234146L109.121 0L111.423 1.7122Z",
    fill: "url(#paint13_linear_1290_3041)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M143.86 10.9456L135.675 37.0603L128.758 37.0091L120.852 10.7773L126.729 10.8212L131.928 31.6017L138.002 10.9017L143.86 10.9456Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6084 4.80858L70.2656 40.1641L103.143 46.7813L108.486 11.4258L75.6084 4.80858Z",
    fill: "#A74E9E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M104.707 48.4258L71.8203 41.8112L77.1651 6.45508L110.045 13.0697L104.707 48.4258Z",
    fill: "url(#paint14_linear_1290_3041)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1447 6.57151L75.6041 4.80078L70.2656 40.1569L71.819 41.8105L77.1447 6.57151Z",
    fill: "#C12929"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1652 6.45444L110.058 13.1642L108.498 11.5105L75.6055 4.80078L77.1652 6.45444Z",
    fill: "url(#paint15_linear_1290_3041)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3352 15.7107L86.6741 27.0375C86.5092 28.1716 86.6234 29.0863 87.0164 29.796C87.4095 30.4985 88.0753 30.9448 89.0073 31.1277C89.9393 31.3107 90.7001 31.1424 91.2897 30.6302C91.8794 30.118 92.2535 29.2911 92.4183 28.157L94.0794 16.8302L98.0738 17.6131L96.419 28.9107C96.1717 30.6009 95.6518 31.9692 94.8529 33.0155C94.0604 34.0619 93.0904 34.779 91.9555 35.1668C90.8142 35.5546 89.6032 35.6204 88.3098 35.3716C87.0164 35.1229 85.9006 34.6033 84.9686 33.8204C84.0302 33.0375 83.3582 31.9985 82.9397 30.7033C82.5212 29.4082 82.4325 27.9155 82.6797 26.2253L84.3345 14.9277L88.3352 15.7107Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4 6.61839L34.793 9.85156L37.4035 44.9165L70.0105 41.6833L67.4 6.61839Z",
    fill: "#A74E9E"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8487 42.8051L39.2411 46.0319L36.6289 10.9685L69.2365 7.73438L71.8487 42.8051Z",
    fill: "url(#paint16_linear_1290_3041)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6341 11.0921L34.7891 9.85547L37.4012 44.9189L39.2399 46.0311L36.6341 11.0921Z",
    fill: "url(#paint17_linear_1290_3041)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6277 10.969L69.2671 7.82264L67.4348 6.70312L34.7891 9.85678L36.6277 10.969Z",
    fill: "url(#paint18_linear_1290_3041)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8415 25.0828C60.6893 23.195 60.2011 21.5633 59.3642 20.195C58.5336 18.834 57.4368 17.8169 56.0673 17.1584C54.6978 16.4925 53.1381 16.2584 51.3946 16.4486L45.1875 17.1072L46.7155 36.2267L52.9225 35.5682C54.6534 35.3852 56.1434 34.8218 57.3924 33.8779C58.6414 32.9413 59.5671 31.7047 60.1631 30.1828C60.7654 28.6535 60.9936 26.9486 60.8415 25.0828ZM55.7883 29.7364C55.0148 30.7901 53.8672 31.3974 52.3392 31.5657L50.4245 31.7633L49.5369 20.656L51.4516 20.4511C52.9733 20.2901 54.2033 20.6486 55.1353 21.5413C56.0609 22.434 56.5935 23.7584 56.733 25.5145C56.8788 27.2779 56.5618 28.6901 55.7883 29.7364Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1.12276 8.34315L0.00390625 44.7969L33.91 46.1829L35.0288 9.72919L1.12276 8.34315Z",
    fill: "#A74E9E"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6706 47.5978L1.76953 46.2076L2.88541 9.75391L36.7928 11.1441L35.6706 47.5978Z",
    fill: "url(#paint19_linear_1290_3041)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M2.87845 9.87838L1.11588 8.3418L0 44.7955L1.76892 46.2076L2.87845 9.87838Z",
    fill: "url(#paint20_linear_1290_3041)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8861 9.75399L36.8125 11.232L35.0436 9.81985L1.11719 8.3418L2.8861 9.75399Z",
    fill: "url(#paint21_linear_1290_3041)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8717 21.1769L17.7766 25.0622L23.2038 25.2452L23.1151 28.8525L17.6879 28.6696L17.5801 32.8769L23.7174 33.0818L23.6223 36.8281L13.4336 36.4915L13.9154 17.2988L24.1041 17.6427L24.009 21.3891L17.8717 21.1769Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1290_3041",
    x1: 223.144,
    y1: 26.9925,
    x2: 257.554,
    y2: 32.3503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF8D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAED24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1290_3041",
    x1: 222.618,
    y1: 30.41,
    x2: 229.252,
    y2: 31.4429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0123,
    stopColor: "#FAED24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF8D28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1290_3041",
    x1: 225.526,
    y1: 11.6935,
    x2: 256.85,
    y2: 16.5708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF8D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAED24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1290_3041",
    x1: 190.118,
    y1: 28.0515,
    x2: 224.825,
    y2: 28.0515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.918e-7,
    stopColor: "#D23C96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F3F98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1290_3041",
    x1: 189.8,
    y1: 31.4793,
    x2: 193.437,
    y2: 31.1629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D23C96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E1F63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1290_3041",
    x1: 188.231,
    y1: 13.4365,
    x2: 220.301,
    y2: 10.6466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D23C96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E1F63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1290_3041",
    x1: 155.311,
    y1: 26.9358,
    x2: 187.397,
    y2: 28.9049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#177C5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39B54A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1290_3041",
    x1: 156.869,
    y1: 28.3575,
    x2: 188.955,
    y2: 30.3268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.34423e-7,
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1454A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1290_3041",
    x1: 155.302,
    y1: 27.0828,
    x2: 157.74,
    y2: 27.2325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E3192"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C75BC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_1290_3041",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(173.556 12.2329) scale(11.6859 13.4865)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 8.52446e-8,
    stopColor: "#2E3192"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C75BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1290_3041",
    x1: 106.279,
    y1: 18.235,
    x2: 155.468,
    y2: 25.8994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.27867e-7,
    stopColor: "#F6EB16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1290_3041",
    x1: 108.687,
    y1: 20.2304,
    x2: 157.628,
    y2: 27.4647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4BD29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6EB16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1290_3041",
    x1: 105.691,
    y1: 23.2029,
    x2: 114.819,
    y2: 24.5522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E026"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6EB16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1290_3041",
    x1: 109.687,
    y1: -3.63446,
    x2: 154.464,
    y2: 3.34241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.27867e-7,
    stopColor: "#F6EB16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1290_3041",
    x1: 71.8232,
    y1: 27.4408,
    x2: 110.047,
    y2: 27.4408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.33195e-7,
    stopColor: "#E74925"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C12929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1290_3041",
    x1: 75.6063,
    y1: 8.98154,
    x2: 110.06,
    y2: 8.98154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000558779,
    stopColor: "#EF4136"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26B58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1290_3041",
    x1: 36.6285,
    y1: 26.8859,
    x2: 71.8475,
    y2: 26.8859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.27867e-7,
    stopColor: "#8E62A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F2C8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1290_3041",
    x1: 31.9822,
    y1: 30.4687,
    x2: 42.4318,
    y2: 26.5502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E62A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F3F98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1290_3041",
    x1: 35.0081,
    y1: 7.0692,
    x2: 69.1207,
    y2: 9.73032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E62A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E2369"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1290_3041",
    x1: 1.76921,
    y1: 28.6757,
    x2: 36.7897,
    y2: 28.6757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.06556e-7,
    stopColor: "#92278F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F3F98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1290_3041",
    x1: -0.213695,
    y1: 27.3034,
    x2: 3.09103,
    y2: 27.2633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.06556e-7,
    stopColor: "#A74499"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C2571"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1290_3041",
    x1: 1.64515,
    y1: 5.50837,
    x2: 36.6715,
    y2: 12.0055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A74499"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F278F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogos);
export default __webpack_public_path__ + "static/media/logos.f1aad2b22d07fbcd664552842cfe3f38.svg";
export { ForwardRef as ReactComponent };